import { useRecordContext, useTranslate } from "ra-core";
import { ReferenceField } from "@/components/admin/reference-field";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import type { Sponsoring } from "../types";

/**
 * Name of the contract type of the sponsoring in the record context, or
 * "Nog geen contracttype" when none is set yet (leads). A balsponsor has no
 * contract type at all, so it reads "Balsponsor" instead.
 */
export const ContractTypeName = ({ className }: { className?: string }) => {
  const translate = useTranslate();
  const record = useRecordContext<Sponsoring>();
  if (!record) return null;

  if (record.kind === "ball") {
    return (
      <span className={cn("text-muted-foreground", className)}>
        {translate("resources.sponsorings.kinds.ball")}
      </span>
    );
  }
  if (record.contract_type_id == null) {
    return (
      <span className={className}>
        {translate("resources.sponsorings.no_contract_type")}
      </span>
    );
  }
  return (
    <ReferenceField
      source="contract_type_id"
      reference="contract_types"
      link={false}
      className={className}
    />
  );
};

/** The contract type as a badge (show pages) */
export const ContractTypeBadge = () => {
  const record = useRecordContext<Sponsoring>();
  if (!record) return null;
  return (
    <Badge
      variant="outline"
      className={
        record.kind !== "ball" && record.contract_type_id == null
          ? "text-muted-foreground"
          : undefined
      }
    >
      <ContractTypeName />
    </Badge>
  );
};
